<template>
    <div class="resetPhone">
        <div class="report-title">
            <h5>{{title}}</h5>
            <!-- <h5>{{title}}</h5> -->
            <!-- <p>{{subTitle}}</p> -->
        </div>
        <!-- <div class="report-title">
            <h5>代保管查询</h5>
            <p>您可通过手机号码查询代保管记录</p>
        </div> -->
        <div class="report-input" v-show="set_id == 1">
            <input type="text" @blur="getIsPhone" v-model = "phone" id="phone" placeholder="请输入新的手机号">
            <div class="report_yzm">
                <input type="text" v-model="qrcode" @blur="getIsqrCode" placeholder="请输入验证码">
                <button @click="buttonStatus" :disabled ='disableds' ref="buttonStatus">{{btncontent}}</button>
            </div>
        </div>
        <div class="report-input" v-show="set_id == 2">
            <!-- @blur= "getIsPassword"
            @blur= "getIsPassword"
            @blur= "getIsPassword" -->
            <input type="password" id="old_password" @blur= "getIsPassword" v-model= "old_password" placeholder="请输入原密码">
            <input type="password" id="reset_password" @blur= "getIsPassword" v-model= "reset_password" placeholder="请输入新密码">
            <input type="password" id="reset_password_sure"  @blur= "getIsNewPassword" v-model= "reset_password_sure" placeholder="请输入确认密码">
            <!-- <div class="report_yzm">
                <input type="text" v-model="qrcode" @blur="getIsqrCode" placeholder="请输入验证码">
                <button @click="buttonStatus" :disabled ='disableds' ref="buttonStatus">{{btncontent}}</button>
            </div> -->
        </div>
        <div class="report-btn">
            <button class="report_submit" @click="submit">确认</button>
        </div>
    </div>
</template>
<script>
import validate from '../lib/js/validata'
import validata from '../lib/js/validata';
export default {
  name: 'resetPhone',
  data () {
    return {
      old_password: "",
      reset_password: '',
      reset_password_sure:'',
      user_id: localStorage.getItem('user_id'),
      phone: '',
      qrcode: '',
      btncontent:'获取验证码',
      disableds: false,
      find_id: null,
      title:'',
    //   subTitle :'您可通过手机号码查询检测报告',
      submitEvent_type: false,
      set_id: this.$route.params.info

    }
  },
  created () {
    this.getId()
  },
  methods: {
    getId () {
      if( this.set_id == '1' ){
        this.submitEvent_type = false;
        this.title = '修改手机号'
      }else if ( this.set_id == '2' ){
        this.submitEvent_type = true;
        this.title = '修改密码'
      }
    },
    getIsPhone () {
      let phones = validate.isPhone(this.phone);
    },
    getIsqrCode () {
      let qrcodes = validate.isqrCode(this.qrcode)
    },
    getIsPassword () {
      let passwords = validate.isPassword(this.old_password)
    },
    getIsNewPassword () {
      let new_passwords = validate.isPasswordOnce(this.reset_password,this.reset_password_sure)
    },
    // 获取验证码
    buttonStatus () {
      let phonenumber = validate.isPhone(this.phone);
      if(!phonenumber.phoneStatus){
        // console.log('请输入合法手机号');
        return
      }
       // 0820
       this.$createDialog({
          type: 'alert',
          content: '验证码已发送，请注意查收',
       }).show()
      let countdown=60; 
      this.setTime(countdown)
      this.$http.api.phoneInfo({
        phone: this.phone
      }).then( result => {
        // console.log(result)
      })
    },
    setTime (countdown) {
      var _this = this
      if (countdown == 0) {
        this.disableds = false
        this.btncontent = "获取验证码"
        countdown = 60
        return;
      } else {
        this.disableds = true
        this.btncontent = "重新发送(" + countdown + ")"
        countdown--
      }
      setTimeout(function() {
        _this.setTime(countdown)
      },1000)
    },
    submit(){
      let _this = this
      // validata.isResetPhone()
      if(validata.isResetPhone().isall || validate.isResetPassword().resetPasssword){
        if (this.set_id == '1') {
          _this.$http.api.resetPhone({
            user_id: _this.user_id,
            input: _this.qrcode,
            phone: _this.phone
          }).then (result => {
          //   console.log(result)
            localStorage.removeItem('user_id')
            localStorage.removeItem('name')
            localStorage.removeItem('phone')
            localStorage.removeItem('role_id')
            localStorage.removeItem('role')
            localStorage.removeItem('type')
            localStorage.removeItem('photo')
            localStorage.removeItem('sex')
            _this.$router.push('/login')
          })
        } else {
          _this.$http.api.resetInfo({
            user_id: _this.user_id,
            password: _this.old_password,
            new_password: _this.reset_password
          }).then( result => {
            localStorage.removeItem('user_id')
            localStorage.removeItem('name')
            localStorage.removeItem('phone')
            localStorage.removeItem('role_id')
            localStorage.removeItem('role')
            localStorage.removeItem('type')
            localStorage.removeItem('photo')
            localStorage.removeItem('sex')
            _this.$router.push('/login')
          })
      }
    }
    }
  }
}
</script>
<style lang="less" scoped>
.resetPhone{
  background: #61B0E3;
  height: 100vh;
  padding-top: 50px;
  box-sizing: border-box;
  .report-title{
    width: 100%;
    text-align: center;
    margin-bottom: 58px;
    h5{
    //   width:143px;
    //   height:36px;
      font-size:18px;
      font-family:MicrosoftYaHei;
      font-weight:400;
      color:rgba(255,255,255,1);
    }
    p{
    //   width:419px;
    //   height:30px;
      font-size:15px;
      font-family:MicrosoftYaHeiLight;
      font-weight:300;
      color: #D5F1F4;
    //   color:rgba(255,255,255,1);
    }
  }
  .report-input{
    //   width: 240px;
    //   height: 100px;
      margin: 0 auto;
      text-align: center;
    //   border: 1px solid #b3daf2;
      border-radius: 5px;
      padding: 0 35px;
      margin-bottom: 149px;
      box-sizing: border-box;
      overflow: hidden;
      input{
        width: 100%;
        height: 50px;
        font-size: 13px;
        background: 0 0;
        border-bottom: 1px solid #b3daf2;
        color: #fff;
        padding-left: 10px;
      }
      ::-webkit-input-placeholder{color:rgba(255,255,255,.8)}
      ::-moz-placeholder{color:rgba(255,255,255,.8)}
      ::-ms-input-placeholder{color:rgba(255,255,255,.8)}
    //   input:last-child{
    //     border: none;
    //   }
      .report_yzm{
          width: 100%;
          height: 50px;
          border-bottom: 1px solid #b3daf2;
          text-align: center;
          overflow: hidden;
          input{
            width: 65%;
            float: left;
            border: none;
          }
          button{
              width: 30%;
              height: 30px;
              font-size: 10px;
              margin-top: 10px;
              border: none;
              border-radius: 18px;
              background: #fff;
              line-height: 24px;
              outline: none;
              color: #61B0E3;
              float: right;
          }
      }
    }
    .report-btn{
      width: 100%;
      text-align: center;
    //   background: #fff;
      .report_submit{
        width:180px;
        height:34px;
        background: #fff;
        border: 1px solid rgba(96,176,227,1);
        // background:rgba(96,176,227,1);
        border-radius:8px;
        line-height: 30px;
        outline: none;
        border: none;
        color: rgba(96,176,227,1);
        // color: #fff;
        font-size: 15px;
      }
    }

}

</style>


